import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import * as serviceWorker from './serviceWorker';

//import './App.css';
import './assets/scss/style.scss';

import { LanguageProvider } from './contexts/LanguageContext';

const history = createBrowserHistory();

const root = document.getElementById('root');

const tree = (
  <HelmetProvider>
    <Router history={history}>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </Router>
  </HelmetProvider>
);

// The build is prerendered (see scripts/prerender.js), so the root element
// usually already contains server-rendered markup: hydrate it instead of
// throwing it away. Fall back to render() for the dev server.
if (root && root.hasChildNodes()) {
  ReactDOM.hydrate(tree, root);
} else {
  ReactDOM.render(tree, root);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
